var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle43B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 49",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.998 32.215a2.5 2.5 0 0 0 2.5 2.5h31a2.5 2.5 0 0 0 2.5-2.5v-15a2.5 2.5 0 0 0-2.5-2.5h-31a2.5 2.5 0 0 0-2.5 2.5v15ZM36.794 45.441a2.5 2.5 0 0 0 2.49 2.274h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6a2.5 2.5 0 0 0-2.49-2.726H38.74a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M38.74 46.715a1.812 1.812 0 0 1-1.622-1.002l-.222-.445a1 1 0 1 0-1.79.894l.223.445a3.812 3.812 0 0 0 3.41 2.108h6.524a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.79-.894l-.222.445a1.812 1.812 0 0 1-1.621 1.002h-6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M16.794 45.441a2.5 2.5 0 0 0 2.49 2.274h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M18.74 46.715a1.812 1.812 0 0 1-1.622-1.002l-.222-.445a1 1 0 1 0-1.79.894l.223.445a3.812 3.812 0 0 0 3.41 2.108h6.524a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.79-.894l-.222.445a1.812 1.812 0 0 1-1.621 1.002h-6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.275 19.508A2.5 2.5 0 0 0 1 21.998v5.434a2.5 2.5 0 0 0 2.274 2.49l6 .545A2.5 2.5 0 0 0 12 27.977v-6.525a2.5 2.5 0 0 0-2.726-2.49l-6 .546Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M2.001 21.453c0-.686.388-1.314 1.002-1.62l.445-.223a1 1 0 0 0-.894-1.79l-.446.223a3.812 3.812 0 0 0-2.107 3.41v6.524c0 1.444.816 2.764 2.107 3.41l.446.223a1 1 0 1 0 .894-1.79l-.445-.222A1.812 1.812 0 0 1 2 27.977v-6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M60.727 29.922a2.5 2.5 0 0 0 2.274-2.49v-5.434a2.5 2.5 0 0 0-2.274-2.49l-6-.545a2.5 2.5 0 0 0-2.726 2.49v6.524a2.5 2.5 0 0 0 2.726 2.49l6-.545Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#BABCC0",
  fillRule: "evenodd",
  d: "M62.001 27.976c0 .687-.388 1.315-1.002 1.622l-.445.222a1 1 0 0 0 .894 1.79l.446-.224A3.812 3.812 0 0 0 64 27.976v-6.523a3.813 3.813 0 0 0-2.108-3.41l-.445-.223a1 1 0 1 0-.894 1.79l.445.222a1.812 1.812 0 0 1 1.002 1.62v6.524Z",
  clipRule: "evenodd"
})));
SvgRectangle43B.viewBox = '0 0 64 49';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle43B);
export default ForwardRef;